// src/redux/services/UdfSlice.js
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const udfApi = createApi({
  reducerPath: "udfApi",
  baseQuery,
  tagTypes: ["Udf"],
  endpoints: (builder) => ({

    getUdfByMasterId: builder.query({
      query: ({id}) => `/export/udf/${id}`,
      transformResponse: (response) =>
        response?.data ?? [],
      providesTags:["Udf"],
    }),

    createUdf: builder.mutation({
      query: ({id, ...data}) => ({
        url: `export/udf/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: { udf: data},
      }),
      invalidatesTags:["Udf"]
    }),
  }),
});

export const {
  useLazyGetUdfByMasterIdQuery,
  useCreateUdfMutation,
} = udfApi;
